import application from 'application/application';

import template from './config.template.html';

import controller from './config.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.account.config', {
				url: '/configuracoes',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Configurações'
				}
			});

	}]);
